
const digest = 'f67cf7e33dfc0ace382553fc66a4f59b1fd29243bcd6671b3dd44dc2e7b7a9da';
const classes = {"patientDidNotRegisteredText":"_patientDidNotRegisteredText_1ulor_1"};
const css = `._patientDidNotRegisteredText_1ulor_1 {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-top: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  